import { IconButton } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { CloseIcon } from "../../../../assets";
import { useDispatch, useSelector } from "react-redux";
import {
  clearWatchListEntries,
  createWatchListEntry,
  getWatchListEntries,
} from "../../actions";
import UpsertWatchListEntryFormHighRiskCountry from "../upsert-watch-list-entry-form";
import { watchListEntriesSelector } from "../../selectors";
import "./createWatchListEntryModal.css";
import { trimFormData } from "../../../../utilities/filters";
import useRoles from "../../../../components/hooks/useRoles";

const CreateWatchListEntryModal = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  const { isCustomerSupport } = useRoles();

  const handleSubmit = (data) => {
    const trimmedData = trimFormData(data);
    dispatch(createWatchListEntry(trimmedData));
    dispatch(getWatchListEntries());
  };

  const hrcEntries = useSelector(watchListEntriesSelector);

  const notHrc = hrcEntries
    .filter((c) => !c.isHrc)
    .map((c) => ({ value: c.countryId, label: c.countryName }));

  useEffect(() => {
    if (open) {
      dispatch(getWatchListEntries());
    }

    return () => {
      dispatch(clearWatchListEntries());
    };
  }, [open]);

  return (
    <React.Fragment>
      <Button disabled={isCustomerSupport} onClick={() => setOpen(true)} className="high-risk-countries-add">
        add
      </Button>

      <Modal style={{ width: 450 }} isOpen={open} toggle={toggle}>
        <ModalHeader
          close={
            <IconButton onClick={toggle} style={{ padding: 8 }}>
              <CloseIcon />
            </IconButton>
          }
        >
          Create High-risk country watchlist entry
        </ModalHeader>
        <ModalBody style={{ height: 450 }}>
          {notHrc.length ? (
            <UpsertWatchListEntryFormHighRiskCountry
              handleSubmit={handleSubmit}
              entries={notHrc}
            />
          ) : null}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default CreateWatchListEntryModal;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/components/create-watch-list-entry-modal/CreateWatchListEntryModal.jsx